import {mergeIf} from "@/helpers"

export default function (auth, data = {}) {
  return [
    ...mergeIf(auth.isAdmin, {
      title: "Vue d'ensemble",
      to: {name: 'dashboard'},
      htmlBefore: '<i class="material-icons">bar_chart</i>',
      htmlAfter: '',
    }),
    {
      title: "Comptes",
      to: '',
      htmlBefore: '<i class="material-icons">person</i>',
      htmlAfter: '',
      items: [
        {
          title: "Tous les comptes",
          to: {name: 'accounts.users'},
        },
        {
          title: "Identité à vérifier",
          to: {name: 'accounts.kyc'},
        },
        {
          title: "Exporter",
          to: {name: 'accounts.export'},
        },
      ]
    },
    {
      title: "Transactions",
      to: '',
      htmlBefore: '<i class="material-icons">swap_horiz</i>',
      htmlAfter: '',
      items: [
        {
          title: "Transactions",
          to: {name: 'transactions.list'},
        },
        {
          title: "Paiements de masse",
          to: {name: 'transactions.bulk_payments'},
        },
        ...mergeIf(
          auth.isAdmin,
          {
            title: "Virements",
            to: {name: 'transactions.bank_transfers'},
          }
        ),
        {
          title: "Recharges",
          to: {name: 'transactions.top_ups'},
        }
      ]
    },
    {
      title: "Incidents",
      to: {name: 'issues'},
      htmlBefore: '<i class="material-icons">report</i>',
      htmlAfter: data.issuesCount ? `<span class="badge badge-pill badge-outline-danger ml-3">${data.issuesCount}</span>` : '',
    },
    ...mergeIf(
      auth.isAdmin,
      {
        title: "Cagnottes",
        to: '',
        htmlBefore: '<i class="material-icons">card_giftcard</i>',
        htmlAfter: '',
        items: [
          {
            title: "Cagnottes",
            to: {name: 'raisings.list'},
          },
          {
            title: "Catégories",
            to: {name: 'raisings.categories'},
          }
        ]
      },
      {
        title: "Cagnottes",
        to: {name: 'raisings.list'},
        htmlBefore: '<i class="material-icons">card_giftcard</i>',
        htmlAfter: ''
      }
    ),
    {
      title: "Marchands",
      to: '',
      htmlBefore: '<i class="material-icons">store</i>',
      htmlAfter: '',
      items: [
        {
          title: "Services marchands",
          to: {name: 'merchants.services'}
        },
        {
          title: "Demandes d'activation",
          to: {name: 'merchants.requests'},
        },
        {
          title: "Comptes bancaires",
          to: {name: 'merchants.bank_accounts'},
        },
        {
          title: "Exporter",
          to: {name: 'merchants.export.accounts'},
        },
        {
          title: "Exporter les services",
          to: {name: 'merchants.export.services'},
        },
      ]
    },
    ...mergeIf(auth.isAdmin, [
      {
        title: "Tableaux de contrôle",
        to: '',
        htmlBefore: '<i class="material-icons">find_in_page</i>',
        htmlAfter: '',
        items: [
          {
            title: "Comptes",
            to: {name: 'inconsistency.accounts'},
          },
          {
            title: "Cagnottes",
            to: {name: 'inconsistency.raisings'},
          },
          {
            title: "Services",
            to: {name: 'inconsistency.services'},
          },
        ]
      },
      {
        title: "Paramètres",
        to: '',
        htmlBefore: '<i class="material-icons">settings</i>',
        htmlAfter: '',
        items: [
          {
            title: "Opérateurs",
            to: {name: 'settings.operators'},
          },
          {
            title: "Banques",
            to: {name: 'settings.banks'},
          },
          {
            title: "Devises",
            to: {name: 'settings.currencies'},
          },
          {
            title: "Rôles",
            to: {name: 'settings.roles'},
          },
          {
            title: "Droits des services",
            to: {name: 'settings.rights'},
          },
        ]
      },
    ]),
  ];
}
